export const removeDuplicateQueryParams = (url: string) => {
  const [baseUrl, queryParams] = url.split("?");
  if (!queryParams) return url;

  const uniqueParams: string[] = [];

  for (const param of queryParams.split("&")) {
    !uniqueParams.includes(param) && uniqueParams.push(param);
  }

  return baseUrl + "?" + uniqueParams.join("&");
};
